<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX310 Series and CX317">
     CX310 Series and CX317
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety" title="Safety information">
     Safety information
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href="safety.html#d0e23" title="Conventions">
      Conventions
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter" title="Learning about the printer">
     Learning about the printer
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer" title="Finding information about the printer">
      Finding information about the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m" title="Selecting a location for the printer">
      Selecting a location for the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-models-topic.html#configured-models" title="Printer configurations">
      Printer configurations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-basic-functions-scanner-topic.html#understanding-basic-functions-scanner" title="Understanding the basic functions of the scanner">
      Understanding the basic functions of the scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-topic.html#using-ADF-and-scanner-glass" title="Using the ADF and scanner glass">
      Using the ADF and scanner glass
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-printer-control-panel-l-topic.html#using-printer-control-panel-l" title="Using the printer control panel">
      Using the printer control panel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-colors-sleep-button-indicator-lights-h-topic.html#understanding-colors-sleep-button-indicator-lights-h" title="Understanding the colors of the Sleep button and indicator lights">
      Understanding the colors of the Sleep button and indicator lights
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="installing-options-chapter.html#installing-options-chapter" title="Additional printer setup">
     Additional printer setup
    </a>
   </p>
   <div id="divd0e791">
    <p class="toc-2-style">
     <a href="internal-options.html#internal-options" title="Installing internal options">
      Installing internal options
     </a>
    </p>
    <p class="toc-2-style">
     <a href="order-installation-topic.html#d0e955" title="Installing hardware options">
      Installing hardware options
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables" title="Attaching cables">
      Attaching cables
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting_up_printer_software.html#d0e1088" title="Setting up the printer software">
      Setting up the printer software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preparing-set-up-printer-ethernet-network-topic.html#d0e1164" title="Networking">
      Networking
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#d0e1516" title="Verifying printer setup">
      Verifying printer setup
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter" title="Loading paper and specialty media">
     Loading paper and specialty media
    </a>
   </p>
   <div id="divd0e1591">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-h1-topic.html#setting-paper-size-and-type-h1" title="Setting the paper size and type">
      Setting the paper size and type
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-h1-topic.html#configuring-universal-paper-settings-h1" title="Configuring Universal paper settings">
      Configuring Universal paper settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-standard-tray-topic.html#loading-standard-tray" title="Loading the 250-sheet tray">
      Loading the 250-sheet tray
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-manual-feeder-topic.html#loading-manual-feeder" title="Loading the manual feeder">
      Loading the manual feeder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-650-sheet-duo-drawer-topic.html#loading-650-sheet-duo-drawer" title="Loading the 650-sheet duo tray">
      Loading the 650-sheet duo tray
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder" title="Loading the multipurpose feeder">
      Loading the multipurpose feeder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#d0e1939" title="Linking and unlinking trays">
      Linking and unlinking trays
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="paper-and-specialty-media-guide-chapter.html#paper-and-specialty-media-guide-chapter" title="Paper and specialty media guide">
     Paper and specialty media guide
    </a>
   </p>
   <div id="divd0e2141">
    <p class="toc-2-style">
     <a href="tips-on-using-letterhead-topic.html#d0e2144" title="Using specialty media">
      Using specialty media
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-group-title.html#paper-guidelines-group-title" title="Paper guidelines">
      Paper guidelines
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-topic.html#d0e2564" title="Supported paper sizes, types, and weights">
      Supported paper sizes, types, and weights
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter" title="Printing">
     Printing
    </a>
   </p>
   <div id="divd0e3357">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#d0e3360" title="Printing a document">
      Printing a document
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-mopria-print-service-topic.html#d0e3549" title="Printing from a mobile device">
      Printing from a mobile device
     </a>
    </p>
    <p class="toc-2-style">
     <a href="storing-print-jobs-h1-topic.html#d0e3659" title="Printing confidential and other held jobs">
      Printing confidential and other held jobs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h1-topic.html#d0e3833" title="Printing information pages">
      Printing information pages
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-printer-control-panel-h1-topic.html#d0e3867" title="Canceling a print job">
      Canceling a print job
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying" title="Copying">
     Copying
    </a>
   </p>
   <div id="divd0e3910">
    <p class="toc-2-style">
     <a href="making-quick-copy-topic.html#d0e3934" title="Making copies">
      Making copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos" title="Copying photos">
      Copying photos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-transparencies-topic.html#d0e4041" title="Copying on specialty media">
      Copying on specialty media
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-to-different-size-topic.html#d0e4183" title="Customizing copy settings">
      Customizing copy settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-an-overlay-message-on-each-page-topic.html#d0e4618" title="Placing information on copies">
      Placing information on copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-copy-job-from-printer-control-panel-topic.html#d0e4668" title="Canceling a copy job">
      Canceling a copy job
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-copies-topic.html#d0e4693" title="Understanding the copying options">
      Understanding the copying options
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing" title="E-mailing">
     E-mailing
    </a>
   </p>
   <div id="divd0e4902">
    <p class="toc-2-style">
     <a href="email-server-setup-topic.html#d0e4927" title="Setting up the printer to e-mail">
      Setting up the printer to e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-using-ews-topic.html#d0e4982" title="Creating an e-mail shortcut">
      Creating an e-mail shortcut
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-using-shortcut-number-topic.html#d0e5023" title="E-mailing a document">
      E-mailing a document
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-an-email-topic.html#canceling-an-email" title="Canceling an e-mail">
      Canceling an e-mail
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Scanning.html#Scanning" title="Scanning">
     Scanning
    </a>
   </p>
   <div id="divd0e5095">
    <p class="toc-2-style">
     <a href="creating-ftp-shortcuts-using-the-ews-topic.html#d0e5098" title="Scanning to an FTP address">
      Scanning to an FTP address
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#d0e5231" title="Scanning to a computer">
      Scanning to a computer
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter" title="Understanding the printer menus">
     Understanding the printer menus
    </a>
   </p>
   <div id="divd0e5311">
    <p class="toc-2-style">
     <a href="menus-list-topic.html#menus-list" title="Menus list">
      Menus list
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supplies-menu-topic.html#supplies-menu" title="Supplies menu">
      Supplies menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-menu-group.html#paper-menu-group" title="Paper menu">
      Paper menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reports-menu-topic.html#d0e6613" title="Reports menu">
      Reports menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-ports-group.html#network-ports-group" title="Network/Ports">
      Network/Ports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="security-menus-group.html#d0e7715" title="Security menu">
      Security menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="general-settings-menu-topic.html#d0e7957" title="Settings menu">
      Settings menu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="conserving-printer-energy-materials.html#conserving-printer-energy-materials" title="Saving money and the environment">
     Saving money and the environment
    </a>
   </p>
   <div id="divd0e11058">
    <p class="toc-2-style">
     <a href="conserving-printer-energy-materials.html#d0e11076" title="Saving paper and toner">
      Saving paper and toner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="conserving-printer-energy-materials.html#d0e11119" title="Saving energy">
      Saving energy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="conserving-printer-energy-materials.html#d0e11518" title="Recycling">
      Recycling
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer" title="Securing the printer">
     Securing the printer
    </a>
   </p>
   <div id="divd0e11585">
    <p class="toc-2-style">
     <a href="security-lock-topic.html#security-lock" title="Using the security lock feature">
      Using the security lock feature
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility" title="Statement of Volatility">
      Statement of Volatility
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-volatile-memory-h2-topic.html#erasing-volatile-memory-h2" title="Erasing volatile memory">
      Erasing volatile memory
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-non-volatile-memory-h1-topic.html#erasing-non-volatile-memory-h1" title="Erasing non-volatile memory">
      Erasing non-volatile memory
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-security-information-b-topic.html#finding-printer-security-information-b" title="Finding printer security information">
      Finding printer security information
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter" title="Maintaining the printer">
     Maintaining the printer
    </a>
   </p>
   <div id="divd0e11737">
    <p class="toc-2-style">
     <a href="storing-supplies-topic.html#storing-supplies" title="Storing supplies">
      Storing supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e11769" title="Cleaning the printer">
      Cleaning the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="checking-parts-status-of-supplies-on-printer-control-panel-h1-topic.html#d0e11865" title="Checking the status of parts and supplies">
      Checking the status of parts and supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="estimated-number-remaining-pages-topic.html#estimated-number-remaining-pages" title="Estimated&nbsp;number of&nbsp;remaining&nbsp;pages">
      Estimated&nbsp;number of&nbsp;remaining&nbsp;pages
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group" title="Ordering supplies">
      Ordering supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-waste-toner-bottle-topic.html#d0e12432" title="Replacing supplies">
      Replacing supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer.html#moving-the-printer" title="Moving the printer">
      Moving the printer
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="administrative-support-chapter.html#administrative-support-chapter" title="Managing the printer">
     Managing the printer
    </a>
   </p>
   <div id="divd0e12755">
    <p class="toc-2-style">
     <a href="finding-advanced-networking-administrator-information-h1-topic.html#finding-advanced-networking-administrator-information-h1" title="Finding advanced networking and administrator information">
      Finding advanced networking and administrator information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="checking-virtual-display-h1-topic.html#checking-virtual-display-h1" title="Checking the virtual display">
      Checking the virtual display
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert" title="Setting up e-mail alerts">
      Setting up e-mail alerts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports" title="Viewing reports">
      Viewing reports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications" title="Configuring supply notifications from the Embedded Web Server">
      Configuring supply notifications from the Embedded Web Server
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-printer-settings-to-other-printers-topic.html#copying-printer-settings-to-other-printers" title="Copying printer settings to other printers">
      Copying printer settings to other printers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-h1-topic.html#restoring-factory-default-h1" title="Restoring factory default settings">
      Restoring factory default settings
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter" title="Clearing jams">
     Clearing jams
    </a>
   </p>
   <div id="divd0e13039">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams" title="Avoiding jams">
      Avoiding jams
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations" title="Identifying jam locations">
      Identifying jam locations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin" title="Paper jam in the standard bin">
      Paper jam in the standard bin
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-front-door-topic.html#paper-jam-in-front-door" title="Paper jam in the front door">
      Paper jam in the front door
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-trays-topic.html#paper-jam-in-trays" title="Paper jam in trays">
      Paper jam in trays
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-manual-feeder-topic.html#paper-jam-in-manual-feeder" title="Paper jam in the manual feeder">
      Paper jam in the manual feeder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-multipurpose-feeder-topic.html#paper-jam-in-multipurpose-feeder" title="Paper jam in the multipurpose feeder">
      Paper jam in the multipurpose feeder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-automatic-document-feeder-top-cover-topic.html#paper-jam-in-automatic-document-feeder-top-cover" title="Paper jam in the automatic document feeder">
      Paper jam in the automatic document feeder
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter" title="Troubleshooting">
     Troubleshooting
    </a>
   </p>
   <div id="divd0e13347">
    <p class="toc-2-style">
     <a href="list-status-error-messages-group.html#list-status-error-messages-group" title="Understanding the printer messages">
      Understanding the printer messages
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems" title="Solving printer problems">
      Solving printer problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-confidential-held-jobs-do-not-print-topic.html#d0e15171" title="Solving print problems">
      Solving print problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-copier-does-not-respond-topic.html#d0e17705" title="Solving copy problems">
      Solving copy problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-scanner-does-not-respond-topic.html#d0e18034" title="Solving scanner problems">
      Solving scanner problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-embedded-web-server-does-not-open-topic.html#trb-embedded-web-server-does-not-open" title="Embedded Web Server does not open">
      Embedded Web Server does not open
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support" title="Contacting customer support">
      Contacting customer support
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices" title="Notices">
     Notices
    </a>
   </p>
   <div id="divd0e18643">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e18646" title="Product information">
      Product information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e18663" title="Edition notice">
      Edition notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#us-government-rights" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices-CD" title="Licensing notices">
      Licensing notices
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks" title="Trademarks">
      Trademarks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels" title="Noise emission levels">
      Noise emission levels
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive" title="Waste from Electrical and Electronic Equipment (WEEE) directive">
      Waste from Electrical and Electronic Equipment (WEEE) directive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#e-waste-notice" title="India E-Waste notice">
      India E-Waste notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal" title="Product disposal">
      Product disposal
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice" title="Static sensitivity notice">
      Static sensitivity notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information" title="Temperature information">
      Temperature information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e18966" title="Laser notice">
      Laser notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-advisory-label" title="Laser advisory label">
      Laser advisory label
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption" title="Power consumption">
      Power consumption
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e19142" title="Applicability of Regulation (EU) 2019/2015 and (EU) 2019/2020">
      Applicability of Regulation (EU) 2019/2015 and (EU) 2019/2020
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-electromagnetic-compatibility" title="Regulatory notices for electromagnetic compatibility">
      Regulatory notices for electromagnetic compatibility
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#federal-communications-commission-fcc-compliance-information-statement" title="Federal Communications Commission (FCC) compliance information statement">
      Federal Communications Commission (FCC) compliance information statement
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e19195" title="Notice to users of the New Zealand telephone network">
      Notice to users of the New Zealand telephone network
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#japanese-vcci-notice" title="日本の VCCI 規定">
      日本の VCCI 規定
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b" title="European Community (EC) directives conformity">
      European Community (EC) directives conformity
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#statement-of-limited-warranty" title="STATEMENT OF LIMITED WARRANTY FOR LEXMARK LASER PRINTERS, LEXMARK LED PRINTERS, AND LEXMARK MULTIFUNCTION LASER PRINTERS">
      STATEMENT OF LIMITED WARRANTY FOR LEXMARK LASER PRINTERS, LEXMARK LED PRINTERS, AND LEXMARK MULTIFUNCTION LASER PRINTERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#device-patent-license" title="DEVICE PATENT LICENSE">
      DEVICE PATENT LICENSE
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue